'use client';

import { usePathname, useSearchParams } from '@/navigation';
import { Suspense, useEffect, useRef } from 'react';

export interface NavigationListenerProps {
  onNavigate(url: string): void;
}

export function NavigationListener(props: NavigationListenerProps) {
  // use a suspense boundary as useSearchParams will suspend client-side
  return (
    <Suspense fallback={null}>
      <NavigationEvents {...props} />
    </Suspense>
  );
}

function NavigationEvents({ onNavigate }: NavigationListenerProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const url = `${pathname}?${searchParams}`;

  // Use a ref to keep the latest callback and initial url
  const callback = useRef(onNavigate);
  const lastUrl = useRef(url);

  useEffect(() => {
    callback.current = onNavigate;
  }, [onNavigate]);

  useEffect(() => {
    if (lastUrl.current !== url) {
      // only call the callback if the url has changed

      lastUrl.current = url;
      callback.current(url);
    }
  }, [url]);

  return null;
}
